module.exports = __webpack_public_path__ + "static/media/grin-squint.8f19da38.svg";